/** Grupos Keycloak tratados como plano Pro no frontend (sem travas de uso). */
export const IDENTITY_GROUP_PRO = '/SUBSCRIBERS/ACTIVE'
export const IDENTITY_GROUP_POTENTIAL_PARTNERS = '/POTENTIAL_PARTNERS'
export const IDENTITY_GROUP_BILLING_EXCEPTION = '/SUBSCRIBERS/BILLING_EXCEPTION'
export const IDENTITY_GROUP_FREE = '/FREE_USER'

export const PRO_SUBSCRIBER_GROUPS = [
  IDENTITY_GROUP_PRO,
  IDENTITY_GROUP_POTENTIAL_PARTNERS,
  IDENTITY_GROUP_BILLING_EXCEPTION,
]

export const FREE_SUBSCRIBER_GROUPS = [
  IDENTITY_GROUP_FREE,
  '/SUBSCRIBERS/FREE',
]

export function userHasProSubscriberGroup(groups = []) {
  return groups.some((group) => PRO_SUBSCRIBER_GROUPS.includes(group))
}
